//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const CityFundsRequestedWidget = ({ count }: { count: number }) => {
  return <StatCard title='City Funds Requested' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default CityFundsRequestedWidget;
